import React from 'react';
import Header from './header';
import './journey.css';

// Import images from the src/assets folder so the bundler includes them
import OrbisDpit from '../assets/OrbisDpit.jpg';

import orbisCasini from '../assets/casini.png'
import ProTv from '../assets/image.png'
import Techsylvania from '../assets/orbisTechsylvania.jpg'
import GenE from '../assets/JA.jpg'

import David from '../assets/david.png'
import Tudor from '../assets/Tudor.png'
import Ioana from '../assets/ioana.png'
import Matei from '../assets/Matei.jpg'
const TIMELINE_EVENTS = [
    {
        id: 1,
        date: 'Summer 2024',
        side: 'left',
        text: `We’re a team of five high schoolers with a shared passion for technology, innovation, and creating real-world impact. Our journey started at DPIT, where we brought our first ideas to life — and proudly won First Place for our project.`,
        image: OrbisDpit,
    },
    {
        id: 2,
        date: 'September 2024',
        side: 'right',
        text: `Motivated to grow, we took part in the Cassini Hackathon, one of Europe’s leading competitions focused on space and technology. It challenged us to think beyond boundaries and work as a team to solve real-world problems.`,
        image: orbisCasini,
    },
    {
        id: 3,
        date: 'February 2024',
        side: 'left',
        text: `Our vision for Orbis reached national audiences when we were featured on "I Like IT" at PRO TV, where we spoke about how innovation and shared transport can help reduce carbon emissions and build sustainable cities.`,
        image: ProTv,
    },
    {
        id: 4,
        date: 'June 2025',
        side: 'right',
        text: `We also had the opportunity to participate in Techsylvania, one of the biggest tech events in Eastern Europe. Surrounded by industry leaders, startups, and innovators, we gained valuable insights and shared our project with an incredible community.`,
        image: Techsylvania,
    },
    {
        id: 5,
        date: 'July 2025',
        side: 'left',
        text: `The highlight of our journey so far? Winning the prestigious J&J Brilliant STEM Innovation Award from JA Europe, which took us to Athens, where we connected with inspiring young innovators from all over the continent.`,
        image: GenE,
    },
];

const TEAM = [
    { id: 1, name: 'Bărbat Matei', role: 'Back-end', image: Matei },
    { id: 2, name: 'Ioana Drânda', role: 'UI/UX', image: Ioana },
    { id: 3, name: 'Ceclan Tudor', role: 'Front-end', image: Tudor },
    { id: 4, name: 'Virlan-Blaj David', role: 'Front-end', image: David },
];

export default function Journey() {
    return (
        <div className="journey-page">
            <Header />

            <main className="journey-content">
                {/* HERO */}
                <section className="journey-hero">
                    <h1 className="journey-title">The story behind Orbis</h1>
                </section>

                {/* TIMELINE */}
                <section className="timeline">
                    {/* vertical line in the middle */}
                    <div className="timeline-line" aria-hidden="true" />

                    {TIMELINE_EVENTS.map((event, index) => (
                        <div
                            key={event.id}
                            className={`timeline-row timeline-row--${event.side}`}
                        >
                            {/* LEFT DATE / CONTENT (depends on side) */}
                            <div className="timeline-col timeline-col--left">
                                {event.side === 'left' ? (
                                    <div className="timeline-date">{event.date}</div>
                                ) : (
                                    <div className="timeline-card">
                                        <p className="timeline-text">{event.text}</p>
                                        <div className="timeline-image-wrapper">
                                            <img
                                                src={event.image}
                                                alt={event.date}
                                                className="timeline-image"
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* CENTER DOT */}
                            <div className="timeline-center">
                                <div className="timeline-dot" />
                            </div>

                            {/* RIGHT DATE / CONTENT (depends on side) */}
                            <div className="timeline-col timeline-col--right">
                                {event.side === 'left' ? (
                                    <div className="timeline-card">
                                        <p className="timeline-text">{event.text}</p>
                                        <div className="timeline-image-wrapper">
                                            <img
                                                src={event.image}
                                                alt={event.date}
                                                className="timeline-image"
                                            />
                                        </div>
                                    </div>
                                ) : (
                                    <div className="timeline-date">{event.date}</div>
                                )}
                            </div>
                        </div>
                    ))}
                </section>

                {/* TEAM SECTION */}
                <section className="team">
                    <h2 className="team-title">Meet the team</h2>
                    <div className="team-grid">
                        {TEAM.map((member) => (
                            <div key={member.id} className="team-member">
                                <div className="team-avatar-wrapper">
                                    <img
                                        src={member.image}
                                        alt={member.name}
                                        className="team-avatar"
                                    />
                                </div>
                                <div className="team-name">{member.name}</div>
                                <div className="team-role">{member.role}</div>
                            </div>
                        ))}
                    </div>
                </section>
            </main>
        </div>
    );
}
